export default "__VITE_ASSET__JZw8tmSR__"